export default __webpack_public_path__ + "static/media/new-york-times.67217586.svg";